$(document).bind('_js_ready', function () {

    let slider = $('.slider_custom_classes');

    function add_custom_slick_classes(currentParam) {
        let current = currentParam;
        current.nextAll('.slick-slide').each(function(index) {
            $(this).addClass('slick-next-' + (index + 1));
        });
        current.prevAll('.slick-slide').each(function(index) {
            $(this).addClass('slick-prev-' + (index + 1));
        });
    }

    slider.on('init', function(event, slick, currentSlide) {
        let current = $(slick.$slides[slick.currentSlide]);
        add_custom_slick_classes(current);
    });

    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(this).find('*[class*="slick-next-"], *[class*="slick-prev-"]').each(function() {
            $(this).removeClass(function(index, className){
                return (className.match (/(^|\s)slick-(prev|next)-[1-9][0-9]?/g) || []).join(' ');
            });
        });
        let current = $(slick.$slides[nextSlide]);
        add_custom_slick_classes(current);
    });

});